export default __webpack_public_path__ + "static/us_consumer_features_ac_mp3_icon-a4c78312950be17c3914e1398343b46b.png";